import { useAppSelector } from '@src/redux';
import { fullNameSelector } from '@src/redux/user';

// The signed-in user's display name, recorded as a version's author.
export const useEditorName = (): string => useAppSelector(fullNameSelector) ?? '';
